// ds-delivery-pdp.js — enlaza el formulario de la ficha de producto con el
// custom element <ds-delivery-date>.
//
// El elemento sabe recalcular la fecha, pero no sabe nada del theme: lee su
// escenario y su cantidad de los atributos. Alguien tiene que escribirlos
// cuando el comprador cambia de variante o de cantidad sin recargar, y ese
// alguien es este fichero. Es todo lo que queda del antiguo
// ds-delivery-estimate.js: el cálculo, el reloj, la cuenta atrás y el repintado
// al reinyectarse por AJAX los hace ahora el componente.
//
// Lo que escribe en el elemento, sacado del mapa [data-ds-variants] que emitió
// Liquid (ds-delivery-estimate.liquid, contexto 'pdp'):
//
//   data-variant    la variante elegida (o la primera disponible)
//   data-qty        el selector de cantidad
//   data-principal  unidades de esa variante en almacén propio
//   data-scenario   de dónde saldría esa variante, o 'none' si no es comprable
//
// y oculta la caja cuando la variante elegida está agotada, que es el único
// trozo de presentación que este fichero decide.
(function () {
  'use strict';

  if (window.__dsDeliveryPdp) return;
  window.__dsDeliveryPdp = true;

  var SEL = 'ds-delivery-date[data-ds-pdp]';
  var SAFE_ID = /^[A-Za-z0-9_-]+$/;

  // El id del formulario del producto lo pone Liquid en data-ds-form. Sin él
  // caemos a document, que es lo que hacía el JS anterior: funciona por el orden
  // del DOM (el formulario principal precede a las tarjetas de recomendados,
  // que también llevan [name=id] cuando el producto es de una sola variante),
  // pero es frágil y por eso ya no es el camino normal.
  function formId(el) {
    var id = el.getAttribute('data-ds-form') || '';
    return SAFE_ID.test(id) ? id : '';
  }

  // Un control de formulario puede estar DENTRO del <form> o fuera y asociado
  // por el atributo form=, y este theme usa las dos formas: el [name="id"] va
  // dentro (product-form.liquid:680) y el selector de cantidad fuera, con form=
  // (:226). La propiedad .form del DOM cubre las dos a la vez; acotar con
  // form.querySelector() solo alcanza la primera y con [form="<id>"] solo la
  // segunda, así que cualquiera de las dos por separado deja al binder a merced
  // de cómo esté escrito cada control.
  // Se compara el ELEMENTO del formulario, no su id. `form.id` no devuelve aquí
  // una cadena: el formulario contiene un <input name="id">, y el acceso por
  // nombre del DOM hace que `form.id` sea ESE INPUT. La comparación con la
  // cadena era siempre falsa, así que esta rama no llegaba a ejecutarse nunca y
  // todo dependía del orden del DOM — justo lo que se quería dejar de hacer.
  function pickControl(el, name, skip) {
    var id = formId(el);
    var form = id ? document.getElementById(id) : null;
    var nodes = document.querySelectorAll('[name="' + name + '"]');
    var fallback = null;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (skip && skip(node)) continue;
      if (!fallback) fallback = node;
      if (form && node.form === form) return node;
    }
    // Sin form conocido, el primero en orden de DOM: el formulario principal va
    // antes que las tarjetas de recomendados, que también llevan [name="id"].
    return fallback;
  }

  // La variante NO salta lo `disabled`. El [name="id"] del formulario lo pinta
  // el servidor con current_variant.id y disabled (product-form.liquid:680), y
  // common.js le quita el atributo al arrancar (productVariants(), :466) y le
  // escribe la variante elegida en cada cambio (:833). O sea que es el control
  // vivo, y mientras dura ese `disabled` su value sigue siendo la variante que
  // acaba de pintar el servidor. Saltarlo solo servía para caer, en ese
  // instante, al [name="id"] de una tarjeta de recomendados y pintar la fecha
  // de otra variante.
  function variantValue(el) {
    var input = pickControl(el, 'id');
    return input ? String(input.value) : '';
  }

  // La cantidad sí salta lo oculto, que ahí es un estado permanente: el bloque
  // 'pack' emite un [name="quantity"] hidden con value 0 (product-form.liquid:876).
  function quantityValue(el) {
    var input = pickControl(el, 'quantity', function (node) { return node.hidden; });
    var n = input ? parseInt(input.value, 10) : 1;
    return !n || n < 1 ? 1 : n;
  }

  function variantMap(el) {
    var node = el.querySelector('[data-ds-variants]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  // Mismo criterio que resuelve Liquid en el primer pintado: la seleccionada si
  // está en el mapa, si no la primera disponible, y si ninguna lo está la
  // primera a secas (producto agotado entero -> caja oculta).
  function pick(map, id) {
    if (id && map[id]) return id;
    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i++) {
      if (map[keys[i]].available !== false) return keys[i];
    }
    return keys.length ? keys[0] : '';
  }

  function setAttr(el, name, value) {
    if (el.getAttribute(name) === value) return;
    el.setAttribute(name, value);
  }

  function update(el) {
    var map = variantMap(el);
    if (!map) return;
    var key = pick(map, variantValue(el));
    var data = key ? map[key] : null;
    var buyable = !!data && data.available !== false;

    // data-scenario el ÚLTIMO: cada atributo dispara un repintado del elemento,
    // y así el último —el que se ve— ya lleva la variante, la cantidad y el
    // umbral coherentes entre sí.
    setAttr(el, 'data-variant', key);
    setAttr(el, 'data-qty', String(quantityValue(el)));
    setAttr(el, 'data-principal', String((data && data.principal) || 0));
    setAttr(el, 'data-scenario', buyable ? (data.scenario || 'none') : 'none');

    var box = el.querySelector('[data-ds-box]');
    if (box && box.hidden !== !buyable) box.hidden = !buyable;
  }

  function sync() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) update(nodes[i]);
  }

  // Los botones +/− del selector de cantidad cambian el value por JS y NO
  // disparan change ni input de los que oye addEventListener (el theme los
  // dispara con jQuery.trigger, que solo llama a los handlers de jQuery, y
  // cart-ajax.js escribe el value a pelo): el click lo cubre. Doble disparo
  // (0/150 ms) porque el theme actualiza el value de forma asíncrona.
  function deferredSync() {
    window.setTimeout(sync, 0);
    window.setTimeout(sync, 150);
  }

  // El drawer «Más información». Nuestra caja emite el enlace
  // [data-target-drawer-banner] y el contenido #estInfoBanner
  // (ds-delivery-estimate.liquid, contexto 'pdp'), pero quien los ataba era
  // product.js —código de Línea Gráfica—, así que nuestra caja colgaba de un
  // fichero ajeno que además se retira con su widget de fechas: por eso el
  // handler se muda aquí, junto al markup que lo necesita (spec D2).
  //
  // Delegado en document porque el bloque se reinyecta por AJAX y un listener
  // atado al enlace se iría con él. El contenido se busca DENTRO del propio
  // <ds-delivery-date> y solo se cae a document si ahí no hay (spec D3):
  // mientras convivieron los dos widgets el id estaba duplicado, y depender del
  // orden del documento ata siempre el primero, sea el de esta caja o no.
  //
  // Hace exactamente lo que hacía product.js:420-431 —mismas clases, mismos
  // huecos— pero con guardas: si falta el enlace, el contenido, el drawer o
  // cualquiera de sus dos huecos, no toca nada y no lanza.
  function openDrawer(e) {
    var target = e.target;
    var link = target && target.closest ? target.closest('[data-target-drawer-banner]') : null;
    if (!link) return;

    // El enlace es href="#": pase lo que pase después, dejarlo navegar saltaría
    // al principio de la página.
    e.preventDefault();

    var scope = link.closest('ds-delivery-date');
    var content =
      (scope && scope.querySelector('#estInfoBanner')) || document.querySelector('#estInfoBanner');
    if (!content) return;

    var drawer = document.querySelector('[data-side-drawer]');
    if (!drawer) return;
    var title = drawer.querySelector('[data-drawer-title]');
    var body = drawer.querySelector('[data-drawer-body]');
    if (!title || !body) return;

    drawer.setAttribute('class', 'yv_side_drawer_wrapper');
    drawer.classList.add('est-info-drawer');
    title.innerHTML = content.getAttribute('data-title') || '';
    body.innerHTML = '<div id="shipping-policy">' + content.innerHTML + '</div>';
    drawer.focus();
    document.body.classList.add('side_Drawer_open');
  }

  function start() {
    sync();
    document.addEventListener('click', openDrawer);
    document.addEventListener('change', deferredSync);
    document.addEventListener('input', deferredSync);
    document.addEventListener('click', deferredSync);
    // Al volver del bfcache el navegador restaura el value de los inputs pero no
    // vuelve a disparar ningún evento: sin esto la caja se quedaría con la
    // cantidad del render y el elemento con el escenario equivocado.
    window.addEventListener('pageshow', deferredSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
